export interface StimulusConfig {
  STIMULI_UPDATE_INTERVAL: number;
  STIMULUS_DECAY_RATE: number;
  SWITCHING_COST: number;
  BASELINE_ACTIVITY: number;
  FORAGE_FOOD_THRESHOLD: number;
}

export const DEFAULT_STIMULUS_CONFIG: StimulusConfig = {
  STIMULI_UPDATE_INTERVAL: 500,
  STIMULUS_DECAY_RATE: 0.05,
  SWITCHING_COST: 0.08,
  BASELINE_ACTIVITY: 0.15,
  FORAGE_FOOD_THRESHOLD: 0.4,
};
